// extracted by mini-css-extract-plugin
export var hat = "text-module--hat--09e9c";
export var hatIconWrap = "text-module--hatIconWrap--bc35e";
export var subtitle = "text-module--subtitle--d50a8";
export var text = "text-module--text--de0fd";
export var textWrap = "text-module--textWrap--5c9d3";
export var title = "text-module--title--f3921";